import { render, staticRenderFns } from "./AlterarPromocaoForm.vue?vue&type=template&id=dff3b976"
import script from "./AlterarPromocaoForm.vue?vue&type=script&lang=ts"
export * from "./AlterarPromocaoForm.vue?vue&type=script&lang=ts"
import style0 from "./AlterarPromocaoForm.vue?vue&type=style&index=0&id=dff3b976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports